var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 48"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 48,
  fill: "#00AE42",
  rx: 4
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  clipPath: "url(#logo_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.798 20.45V38H35V24.39zM24.798 10v8.766L35 22.706V10zM13 27.55V10h10.202v13.61zM13 38v-8.766l10.202-3.94V38z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M13 10h22v28H13z"
})))));
export default SvgLogo;